import { Component, OnInit, ViewEncapsulation, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { WidgetSearch } from '../../models/WidgetSearch';
import { GlobalsService } from '../../services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '../../models/DQOIReferenceData';
import { CommonFunctions } from '../../static/common-functions';
import { DashboardQueries } from '../../enums/DashboardQueries';
import { widgetFilters } from '../../enums/widgetFilters';
import { GCItem } from '../../models/GCItem';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { GItem } from '../../models/GItem';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { DashboardService } from '../../services/dashboard.service';
import { CreditMemoWidgetUser } from '../../models/CreditMemoWidgetUser';

@Component({
    selector: 'widget-search',
    templateUrl: './widget-search.component.html',
    styleUrls: ['./widget-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WidgetSearchComponent implements OnInit, OnDestroy {

    sch: WidgetSearch = new WidgetSearch();

    qry_rd: DQOIReferenceDataQuery;
    referenceData: DQOIReferenceData;
    subs_dataRef: Subscription;
    selectedStates: any;
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    public DashboardQueries = DashboardQueries;
    @Input() dashboardQuery: DashboardQueries = DashboardQueries.none;
    @Input() visibleWidgetFilters: widgetFilters[] = [];
    @Input() inputSearchParams: WidgetSearch;
    @Input() madeActive: boolean = false;
    @Input() coordinatorConstructionOnly: boolean = false;
    @Output() search: EventEmitter<WidgetSearch> = new EventEmitter(true);

    customerCBOVisible: boolean = false;
    customerInclusivityVisible: boolean = false;
    classCBOVisible: boolean = false;
    svcConstCBOVisible: boolean = false;
    stateCBOVisible: boolean = false;
    acctMgrCBOVisible: boolean = false;
    constAdminCBOVisible: boolean = false;
    svcMgrCBOVisible: boolean = false;
    purchaserCBOVisible: boolean = false;
    billerCBOVisible: boolean = false;
    buyerCBOVisible: boolean = false;
    orderStatusCBOVisible: boolean = false;
    requestorCBOVisible: boolean = false;
    salesPersonCBOVisible: boolean = false;
    disputeAmmountCBOVisible: boolean = false;
    creditMemoStatusCBOVisible: boolean = false;
    creditReasonCodeCBOVisible: boolean = false;
    dateRangeVisible: boolean = false;
    invoiceStatusCBOVisible: boolean = false;
    locationsCBOVisible: boolean = false;
    techniciansCBOVisible: boolean = false;
    statusCBOVisible: boolean = false;
    divisionsCBOVisible: boolean = false;
    contractAdminCBOVisible: boolean = false;
    supplierCBOVisible: boolean = false;
    dispatchNbrVisible: boolean = false;
    orderNbrVisible: boolean = false;
    inventoryNbrVisible: boolean = false;
    quoteNbrVisible: boolean = false;
    invoiceNbrVisible: boolean = false;
    fiscalVisible: boolean = false;
    techCreatedVisible: boolean = false;
    invoiceSalesSummaryTypesVisible: boolean = false;
    regionsCBOVisible: boolean = false;
    discreetBillerCBOVisible: boolean = false;
    defaultSubmitterCBOVisible: boolean = false;
    isSubCBOVisible: boolean = false;
    onCallRegionCBOVisible: boolean = false;
    filterRegions: GItem[] = [];
    filterDivisions: GItem[] = [];
    daysAgedVisible: boolean = false;
    priorityVisible: boolean = false;
    projectManagerCBOVisible: boolean = false;
    rankCBOVisible: boolean = false;
    techCreateds: GItem[] = [];
    //filtered datasets
    custLocations: GCItem[] = [];

    constAdmins: GItem[] = [];
    invoiceStatuses: GItem[] = [];
    constIsSubs: GItem[] =
        [
            { value: "0", description: "All", category: null, canSelect: true, reference: null },
            { value: "1", description: "True", category: null, canSelect: true, reference: null },
            { value: "2", description: "False", category: null, canSelect: true, reference: null },
        ];
    disputeAmmount: GItem[] =
        [
            { value: "0", description: "All", category: null, canSelect: true, reference: null },
            { value: "1", description: "0.00 - 25.00", category: null, canSelect: true, reference: null },
            { value: "2", description: "25.01 - 500.00", category: null, canSelect: true, reference: null },
            { value: "3", description: "500.01 - 1000.00", category: null, canSelect: true, reference: null },
            { value: "4", description: "1000.01 - 2500.00", category: null, canSelect: true, reference: null },
            { value: "5", description: "2500.01+", category: null, canSelect: true, reference: null }
        ];
    fiscalYears: string[] = ['2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008', '2007', '2006', '2005', '2004', '2003', '2002', '2001', '2000'];
    invoiceSalesSummaryTypes: string[] = ['Profit', 'Sales', 'Costs', 'Taxes', 'Material Costs', 'Material Sales', 'Labor Costs', 'Labor Sales'];

    featureFlagSet: any = {};
    creditMemoUser: CreditMemoWidgetUser;
    subs_dataRefUpdated: Subscription;
    constructor(private globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, protected featureFlagService: FeatureFlagService, private dashboardService: DashboardService) {

        this.qry_rd = qry_rd;

        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();

        this.subs_dataRefUpdated = combineLatest([this.qry_rd.referenceDataUpdated, this.featureFlagService.featureFlagSets]).subscribe(([refData, flags]) => {
            if (refData) {
                this.referenceData = refData;
                this.constAdmins = this.referenceData.getActiveContAdmins();
                this.invoiceStatuses = this.referenceData.invoiceStatus;
                if (this.visibleWidgetFilters.indexOf(widgetFilters.invoiceStatusApproval) > -1) {
                    this.invoiceStatuses = CommonFunctions.removeValueFromGItemArray(this.invoiceStatuses, "BE554120-3958-4663-AFB7-198FB28A53D1");
                    this.invoiceStatuses = CommonFunctions.removeValueFromGItemArray(this.invoiceStatuses, "346C497F-D5B1-4325-9F6C-633DEBCC37A9");
                    this.invoiceStatuses = CommonFunctions.removeValueFromGItemArray(this.invoiceStatuses, "99D89AAE-2DED-4E5D-989A-D66E244DF239");
                    this.invoiceStatuses = CommonFunctions.removeValueFromGItemArray(this.invoiceStatuses, "347A0CDC-E710-48A8-8C9D-491C06171F43");
                }
            }
            this.featureFlagSet = flags || {};
            if (refData && flags) {
                this.setDivisionsAndRegions();
            }
        });

        this.techCreateds.push(new GItem({ value: 0, description: "", category: null, canSelect: true, reference: null }));
        this.techCreateds.push(new GItem({ value: 1, description: "Tech Created Only", category: null, canSelect: true, reference: null }));
        this.techCreateds.push(new GItem({ value: 2, description: "Hide Tech Created", category: null, canSelect: true, reference: null }));
    }

    ngOnInit() {
        this.customerCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.customer) > -1 ? true : false;
        this.customerInclusivityVisible = this.visibleWidgetFilters.indexOf(widgetFilters.customerInclusivity) > -1 ? true : false;
        this.classCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.class) > -1 ? true : false;
        this.svcConstCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.svcConst) > -1 ? true : false;
        this.stateCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.state) > -1 ? true : false;
        this.acctMgrCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.acctMgr) > -1 ? true : false;
        this.constAdminCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.contAdmin) > -1 ? true : false;
        this.purchaserCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.purchaser) > -1 ? true : false;
        this.svcMgrCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.svcMgr) > -1 ? true : false;
        this.billerCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.biller) > -1 ? true : false;
        this.buyerCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.buyer) > -1 ? true : false;

        this.requestorCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.requestor) > -1 ? true : false;

        this.orderStatusCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.orderStatus) > -1 ? true : false;
        this.isSubCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.isSub) > -1 ? true : false;
        this.onCallRegionCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.onCallRegion) > -1 ? true : false;

        this.disputeAmmountCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.disputeAmmount) > -1 ? true : false;
        this.creditMemoStatusCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.creditMemoStatus) > -1 ? true : false;
        this.creditReasonCodeCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.disputeAmmount) > -1 ? true : false;
        this.salesPersonCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.salesPerson) > -1 ? true : false;
        this.dateRangeVisible = this.visibleWidgetFilters.indexOf(widgetFilters.dateRange) > -1 ? true : false;
        this.invoiceStatusCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.invoiceStatus) > -1 || this.visibleWidgetFilters.indexOf(widgetFilters.invoiceStatusApproval) > -1 ? true : false;
        this.locationsCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.locations) > -1 ? true : false;
        this.techniciansCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.technicians) > -1 ? true : false;
        this.statusCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.status) > -1 ? true : false;
        this.divisionsCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.divisions) > -1 ? true : false;
        this.contractAdminCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.contAdmin) > -1 ? true : false;
        this.supplierCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.supplier) > -1 ? true : false;
        this.dispatchNbrVisible = this.visibleWidgetFilters.indexOf(widgetFilters.dispatchNbr) > -1 ? true : false;
        this.orderNbrVisible = this.visibleWidgetFilters.indexOf(widgetFilters.orderNbr) > -1 ? true : false;
        this.inventoryNbrVisible = this.visibleWidgetFilters.indexOf(widgetFilters.inventoryNbr) > -1 ? true : false;
        this.quoteNbrVisible = this.visibleWidgetFilters.indexOf(widgetFilters.quoteNbr) > -1 ? true : false;
        this.invoiceNbrVisible = this.visibleWidgetFilters.indexOf(widgetFilters.invoiceNbr) > -1 ? true : false;
        this.fiscalVisible = this.visibleWidgetFilters.indexOf(widgetFilters.fiscalYear) > -1 ? true : false;
        this.techCreatedVisible = this.visibleWidgetFilters.indexOf(widgetFilters.techCreated) > -1 ? true : false;
        this.invoiceSalesSummaryTypesVisible = this.visibleWidgetFilters.indexOf(widgetFilters.invoiceSalesSummaryTypes) > -1 ? true : false;
        this.regionsCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.regions) > -1 ? true : false;
        this.discreetBillerCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.discreetBiller) > -1 ? true : false;
        this.defaultSubmitterCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.defaultSubmitter) > -1 ? true : false;
        this.daysAgedVisible = this.visibleWidgetFilters.indexOf(widgetFilters.daysAged) > -1 ? true : false;
        this.priorityVisible = this.visibleWidgetFilters.indexOf(widgetFilters.priority) > -1 ? true : false;
        this.projectManagerCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.projectManager) > -1 ? true : false;
        this.rankCBOVisible = this.visibleWidgetFilters.indexOf(widgetFilters.rank) > -1 ? true : false;


        if (this.inputSearchParams) {
            if (this.inputSearchParams.startDate) {
                this.inputSearchParams.startDate = new Date(this.inputSearchParams.startDate);
            }
            if (this.inputSearchParams.endDate) {
                this.inputSearchParams.endDate = new Date(this.inputSearchParams.endDate);
            }
            this.sch = this.inputSearchParams;
        }
        if (this.sch.customerIds && this.sch.customerIds.length > 0) {
            this.customerCBOChanged(null);
        }

        this.sch.emptySearch = (this.inputSearchParams && this.inputSearchParams.emptySearch) ? this.inputSearchParams.emptySearch : false;
        this.search.emit(this.sch);

        if (this.visibleWidgetFilters.indexOf(widgetFilters.invoiceStatusApproval) > -1) {
            this.invoiceStatuses = CommonFunctions.removeValueFromGItemArray(this.invoiceStatuses, "BE554120-3958-4663-AFB7-198FB28A53D1");
            this.invoiceStatuses = CommonFunctions.removeValueFromGItemArray(this.invoiceStatuses, "346C497F-D5B1-4325-9F6C-633DEBCC37A9");
            this.invoiceStatuses = CommonFunctions.removeValueFromGItemArray(this.invoiceStatuses, "99D89AAE-2DED-4E5D-989A-D66E244DF239");
            this.invoiceStatuses = CommonFunctions.removeValueFromGItemArray(this.invoiceStatuses, "347A0CDC-E710-48A8-8C9D-491C06171F43");
        }

    }

    private setDivisionsAndRegions() {
        //NOTE: [dturco 05.16.2025] This code flow is odd, and can be simplified, also this flag has been here a long time and should be removed
        //if loading the creditmemoapproval widget, pull the user profile and limit their data filtering options accordingly
        if (this.dashboardQuery === DashboardQueries.creditMemoApproval && this.featureFlagSet["credit-memo-approval-widget-high-priority-changes-pt-2"]) {
            this.dashboardService.getCreditMemoWidgetUser(this.globals.userId).subscribe({
              next: data => {
                  this.creditMemoUser = data.result;

                  if (this.featureFlagSet["division-region-reference-restore"]) {
                      this.referenceData.regions.forEach(region => {
                          if (this.creditMemoUser.regionIds?.length > 0 && !this.creditMemoUser.regionIds.includes(region.value)) {
                              this.referenceData.regions = CommonFunctions.removeValueFromGItemArray(this.referenceData.regions, region.value);
                          }
                      });

                      this.referenceData.divisions.forEach(division => {
                          if (this.creditMemoUser.divisionIds?.length > 0 && !this.creditMemoUser.divisionIds.includes(division.value)) {
                              this.referenceData.divisions = CommonFunctions.removeValueFromGItemArray(this.referenceData.divisions, division.value);
                          }
                      });
                  }
                  else {
                      this.filterRegions.forEach(region => {
                          if (this.creditMemoUser.regionIds?.length > 0 && !this.creditMemoUser.regionIds.includes(region.value)) {
                              this.filterRegions = CommonFunctions.removeValueFromGItemArray(this.filterRegions, region.value);
                          }
                      });

                      this.filterDivisions.forEach(division => {
                          if (this.creditMemoUser.divisionIds?.length > 0 && !this.creditMemoUser.divisionIds.includes(division.value)) {
                              this.filterDivisions = CommonFunctions.removeValueFromGItemArray(this.filterDivisions, division.value);
                          }
                      });
                  }
              },
              error: (err) => {
                  console.error("Error loading credit memo widget user data", err);
                  //least give them all the regions and divisions to pick from
                  if (!this.featureFlagSet["division-region-reference-restore"] && this.referenceData) {
                      this.filterDivisions = Object.assign([], this.referenceData.divisions);
                      this.filterRegions = Object.assign([], this.referenceData.regions);
                }
              }
            });
        } else {
            if (!this.featureFlagSet["division-region-reference-restore"] && this.referenceData) {
                this.filterDivisions = Object.assign([], this.dashboardQuery == DashboardQueries.zuggitCpDispatchNeedsParts ? this.referenceData?.cpDivisions : this.referenceData.divisions);
                this.filterRegions = Object.assign([], this.dashboardQuery == DashboardQueries.zuggitCpDispatchNeedsParts ? this.referenceData?.cpRegions : this.referenceData.regions);
            }
        }
    }
    ngOnDestroy() {
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }
    readOnly: boolean = false;
    public collision = { horizontal: "flip", vertical: "fit" };

    public onToggle(): void {
        this.madeActive = !this.madeActive;
        if (!this.madeActive) {
            this.search.emit(this.sch);
        }
    }

    doSearch() {
        this.setCustomStatus();
        //alert(JSON.stringify(this.sch));
        this.search.emit(this.sch);
    }

    clear() {
        Object.keys(this.sch).forEach(function(item) {
            item = null;
        });
        //this.sch.srvConst = null;
        this.sch = new WidgetSearch();
        this.doSearch();
    }
    customerCBOChanged(e: any) {
        this.custLocations = [];
        if (CommonFunctions.hasValue(this.sch.customerIds) && this.referenceData) {
            this.custLocations = this.referenceData.getMultiCustomerLocations(this.sch.customerIds);
        } else {
            this.custLocations = [];
        }
    }
    classCBOChanged(e: any) {

    }
    svcConstCBOChanged(e: any) {
        if (this.coordinatorConstructionOnly && e != 2) {
            this.sch.contractAdminIds = [];
        }
    }
    stateCBOChanged(e: any) {

    }
    acctMgrCBOChanged(e: any) {

    }
    contAdminCBOChanged(e: any) {

    }
    purchaserCBOChanged(e: any) {

    }
    priorityCBOChanged(e: any) {

    }
    projectManagerCBOChanged(e: any) {

    }
    rankCBOChanged(e: any) {

    }
    svcMgrCBOChanged(e: any) {

    }
    billerCBOChanged(e: any) {

    }
    buyerCBOChanged(e: any) {

    }
    salesPersonCBOChanged(e: any) {

    }
    invoiceStatusCBOChanged(e: any) {

    }
    locationCBOChanged(e: any) {

    }
    technicianCBOChanged(e: any) {

    }
    statusCBOChanged(e: any) {

    }
    divisionCBOChanged(e: any) {

    }
    fiscalChanged(e: any) {

    }
    invoiceSalesSummaryTypesChanged(e: any) {

    }
    daysAgedChanged(e: any) {

    }
    regionsCBOChanged(e: any) {
    }

    discreetBillerCBOChanged(e: any) {
    }

    defaultSubmitterCBOChanged(e: any) {
    }

    customerInclusivityChanged(e: any, setting: boolean) {
        this.sch.customerInclusivity = setting;
    }

    isCustomSearch(): boolean {
        if (this.featureFlagSet['quotes-needing-approval-update']) {
            if (this.sch.acctMgrId || this.sch.acctMgrIds || this.sch.buyerIds || this.sch.billerId || this.sch.billerIds || this.sch.classIds || this.sch.contractAdminId || this.sch.contractAdminIds || this.sch.endDate || this.sch.salespersonId || this.sch.salesPersonIds || this.sch.serviceMgrId
                || this.sch.startDate || (this.sch.states && this.sch.states.length > 0) || this.sch.statusId || this.sch.locationId || this.sch.locationIds || this.sch.technicianId || this.sch.technicians || (this.sch.divisionIds && this.sch.divisionIds.length > 0) || (this.sch.requestedByIds && this.sch.requestedByIds.length > 0)
                || (this.sch.suppliers && this.sch.suppliers.length > 0) || (this.sch.isSub) || (this.sch.onCallRegions && this.sch.onCallRegions.length > 0)
                || this.sch.customerId || this.sch.customerIds || this.sch.invoiceStatus || this.sch.statusIds || this.sch.invoiceStatuses || (this.sch.regionIds && this.sch.regionIds.length > 0) || this.sch.invoiceSalesSummaryTypes || this.sch.discreetBillerIds || this.sch.defaultSubmitterIds || this.sch.daysAged
                || this.sch.srvConstInt || this.sch.purchaserPersonIds || this.sch.priorityIds || (this.sch.projectManagerIds && this.sch.projectManagerIds.length > 0) || (this.sch.rankOrderIds && this.sch.rankOrderIds.length > 0)) {
                return true;
            } else {
                return false;
            }
        } else {
            if (this.sch.acctMgrId || this.sch.acctMgrIds || this.sch.buyerIds || this.sch.billerId || this.sch.billerIds || this.sch.classIds || this.sch.contractAdminId || this.sch.contractAdminIds || this.sch.endDate || this.sch.salespersonId || this.sch.salesPersonIds || this.sch.serviceMgrId
                || this.sch.startDate || (this.sch.states && this.sch.states.length > 0) || this.sch.statusId || this.sch.locationId || this.sch.locationIds || this.sch.technicianId || this.sch.technicians || (this.sch.divisionIds && this.sch.divisionIds.length > 0) || (this.sch.requestedByIds && this.sch.requestedByIds.length > 0)
                || (this.sch.suppliers && this.sch.suppliers.length > 0) || (this.sch.isSub) || (this.sch.onCallRegions && this.sch.onCallRegions.length > 0)
                || this.sch.customerId || this.sch.customerIds || this.sch.invoiceStatus || this.sch.statusIds || this.sch.invoiceStatuses || (this.sch.regionIds && this.sch.regionIds.length > 0) || this.sch.invoiceSalesSummaryTypes || this.sch.discreetBillerIds || this.sch.defaultSubmitterIds || this.sch.daysAged || this.sch.purchaserPersonIds || this.sch.priorityIds || (this.sch.projectManagerIds && this.sch.projectManagerIds.length > 0) || (this.sch.rankOrderIds && this.sch.rankOrderIds.length > 0) ) {
                return true;
            } else {
                return false;
            }
        }
    }

    setEmptySearch() {
        if (this.isCustomSearch()) {
            this.sch.emptySearch = false;
        } else {
            this.sch.emptySearch = true;
        }
    }

    setCustomStatus() {
        if (this.isCustomSearch()) {
            this.sch.customSearch = true;
        } else {
            this.sch.customSearch = false;
        }
    }
}

